var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "battery-container" }, [
    _c("div", { staticClass: "battery" }, [
      _c(
        "div",
        {
          staticClass: "battery-outline",
          style: { borderColor: _vm.batteryColor },
        },
        [
          _vm._l(5, function (i) {
            return [
              _c("div", {
                key: i,
                staticClass: "battery-bar",
                style: {
                  opacity: i <= _vm.filledBars ? 1 : 0,
                  backgroundColor: _vm.batteryColor,
                },
              }),
            ]
          }),
        ],
        2
      ),
    ]),
    _vm.withText
      ? _c("span", { staticClass: "battery-text" }, [
          _vm._v(_vm._s(_vm.value) + "%"),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }